import { render, staticRenderFns } from "./reportorder.vue?vue&type=template&id=4b1ebc60"
import script from "./reportorder.vue?vue&type=script&lang=js"
export * from "./reportorder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports